const storagePrefix = `APP_${process.env.VUE_APP_NAME}`;
export const storage = {
  setItem: (key, value) => {
    localStorage.setItem(`${storagePrefix}_${key}`, value);
  },
  getItem: (key) => {
    return localStorage.getItem(`${storagePrefix}_${key}`);
  },
  removeItem: (key) => {
    if (storage.getItem(key)) {
      localStorage.removeItem(`${storagePrefix}_${key}`);
    }
  },
  removeItems: (keys) => {
    for (let key of keys) {
      storage.removeItem(key);
    }
  }
};

export const storageSession = {
  setItem: (key, value) => {
    sessionStorage.setItem(`${storagePrefix}_${key}`, value);
  },
  getItem: (key) => {
    return sessionStorage.getItem(`${storagePrefix}_${key}`);
  },
  removeItem: (key) => {
    if (storageSession.getItem(key)) {
      sessionStorage.removeItem(`${storagePrefix}_${key}`);
    }
  },
  removeItems: (keys) => {
    for (let key of keys) {
      sessionStorage.removeItem(key);
    }
  }
};
